import styled from 'styled-components';
import { pallette } from '@equinor/opt-ui-core';
import { colors } from 'AppTheme/constants';
export const Box = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 4px;
`;
export const LegendBox = styled.div `
  text-align: left;
  display: flex;
  flex-direction: column;
`;
export const InnerBox = styled.div `
  display: flex;
  align-items: center;
  background-color: ${colors.SLATE_BLUE_100};
  border-radius: 5px;
  input {
    font-family: 'Equinor';
    font-size: 0.825rem;
  }
`;
export const FilterHeaderBox = styled.div `
  position: sticky;
  top: 0;
  z-index: 1;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  background-color: ${colors.SLATE_BLUE_100};
`;
export const BaseText = styled.span `
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  color: #73b1b5;
  font-weight: 500;
`;
export const Text = styled(BaseText) `
  text-align: center;
`;
export const LeftIndentText = styled(BaseText) `
  margin-left: 10px;
  white-space: nowrap;
`;
export const Label = styled.span `
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.333em;
  color: ${(props) => pallette(props)?.text.tertiary};
  margin: 0px;
`;
export const InvisibleAnchor = styled.div `
  width: 1px;
  height: 1px;
  background-color: transparent;
`;
export const InvisibleAnchorFollow = styled.div `
  width: 10px;
  height: 10px;
  background-color: transparent;
  z-index: 5000;
  position: fixed;
  left: ${(props) => `${props?.left}px` || '0px'};
  top: ${(props) => `${props?.top}px` || '0px'};
`;
export const InvisibleTabsFlexBlock = styled.div `
  flex: 0 0 280px;
  height: 40px;
  @media only screen and (max-width: 900px) {
    display: none;
  }
`;
export const OverlayDisabledBlock = styled.div `
  position: absolute;
  width: 100%;
  width: ${({ disabled }) => (disabled ? '100%' : 0)};
  height: ${({ disabled }) => (disabled ? '100%' : 0)};
  top: 0;
  left: 0;
  background-color: ${({ opacity }) => opacity ? `rgba(0, 0, 0, ${opacity})` : 'rgba(0, 0, 0, 0.7)'};
  z-index: 100;
  cursor: not-allowed;
`;
// Backdrop that allows you to include not only target element into interaction zone but also siblings controls to target element
export const CustomBackdrop = styled.div `
  opacity: 0.5;
  width: 100svw;
  height: 100svh;
  position: fixed;
  top: 0;
  left: 0;
`;
